import React, { forwardRef } from 'react';
import { styled } from '@compiled/react';
import Textfield from '@atlaskit/textfield';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { COMPAL_LISTBOX_ID, COMPAL_LISTBOX_ITEM_ID, SEARCH_INPUT_TEST_ID } from '../constants';

type SearchInputProps = React.ComponentProps<typeof TextFieldStyle> & {
	activeId?: string;
};

export const CommandPaletteSearchInput: React.FC<SearchInputProps> = forwardRef(
	({ activeId, ...rest }, ref) => (
		<TextFieldStyle
			appearance="none"
			testId={SEARCH_INPUT_TEST_ID}
			ref={ref}
			aria-expanded
			aria-controls={COMPAL_LISTBOX_ID}
			aria-activedescendant={`${COMPAL_LISTBOX_ITEM_ID}-${activeId}`}
			role="combobox"
			{...rest}
		/>
	),
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TextFieldStyle = styled(Textfield)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	':hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
		backgroundColor: 'transparent !important',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text', colors.N800),
	border: 'none',
	padding: `${token('space.075', '6px')} ${token('space.050', '4px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'input,input:not([data-compact])': {
		paddingTop: '0px',
		paddingBottom: '0px',
		paddingLeft: `${token('space.050', '4px')}`,
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
		fontSize: '18px',
		height: '20px ',
		lineHeight: '20px',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'input::placeholder': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		color: token('color.text.subtlest', colors.N200),
	},
});
